import { get, set, isEmpty } from 'lodash'
import mapAwardCategories from 'helpers/mapAwardCategories'
import { ACTIVITY_STATES } from 'constants/enums'

const SETUP = 'dofe-fo/activity/SETUP'
const SETUP_SUCCESS = 'dofe-fo/activity/SETUP_SUCCESS'
const SETUP_FAIL = 'dofe-fo/activity/SETUP_FAIL'

const EDIT = 'dofe-fo/activity/EDIT'
const EDIT_SUCCESS = 'dofe-fo/activity/EDIT_SUCCESS'
const EDIT_FAIL = 'dofe-fo/activity/EDIT_FAIL'

const APPROVAL = 'dofe-fo/activity/APPROVAL '
const APPROVAL_SUCCESS = 'dofe-fo/activity/APPROVAL_SUCCESS '
const APPROVAL_FAIL = 'dofe-fo/activity/APPROVAL_FAIL '

const GET_LOGS = 'dofe-fo/activity/GET_LOGS'
const GET_LOGS_SUCCESS = 'dofe-fo/activity/GET_LOGS_SUCCESS'
const GET_LOGS_FAIL = 'dofe-fo/activity/GET_LOGS_FAIL'

const GET_OVERVIEW = 'dofe-fo/activity/GET_OVERVIEW'
const GET_OVERVIEW_SUCCESS = 'dofe-fo/activity/GET_OVERVIEW_SUCCESS'
const GET_OVERVIEW_FAIL = 'dofe-fo/activity/GET_OVERVIEW_FAIL'

const GET_CATEGORIES = 'dashboard/activity/GET_CATEGORIES'
const GET_CATEGORIES_SUCCESS = 'dashboard/activity/GET_CATEGORIES_SUCCESS'
const GET_CATEGORIES_FAIL = 'dashboard/activity/GET_CATEGORIES_FAIL'

const CREATE_ACTIVITY = 'dashboard/awards/CREATE_ACTIVITY'
const CREATE_ACTIVITY_SUCCESS = 'dashboard/awards/CREATE_ACTIVITY_SUCCESS'
const CREATE_ACTIVITY_FAIL = 'dashboard/awards/CREATE_ACTIVITY_FAIL'

const UPLOAD_ACTIVIT_REPORT = 'dashboard/awards/UPLOAD_ACTIVIT_REPORT'
const UPLOAD_ACTIVIT_REPORT_SUCCESS =
  'dashboard/awards/UPLOAD_ACTIVIT_REPORT_SUCCESS'
const UPLOAD_ACTIVIT_REPORT_FAIL = 'dashboard/awards/UPLOAD_ACTIVIT_REPORT_FAIL'

// TODO: Use separate reducer for each of the entity and combine them
const initialState = {
  add: {
    activityId: null,
    loading: false
  },
  setup: {
    loading: false,
    loaded: false
  },
  edit: {
    loading: false,
    loaded: false
  },
  approval: {
    loading: false,
    loaded: false
  },
  logs: {
    loaded: false,
    data: null
  },
  revise: {
    loaded: false,
    data: null
  },
  overview: {
    loaded: false,
    data: null
  }
}

/* eslint-disable */
export default function activity(state = initialState, action = {}) {
  switch (action.type) {
    case SETUP:
      return {
        ...state,
        setup: {
          ...state.setup,
          loading: true
        }
      }

    case SETUP_SUCCESS:
      return {
        ...state,
        setup: {
          ...state.setup,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case SETUP_FAIL:
      return {
        ...state,
        setup: {
          ...state.setup,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case CREATE_ACTIVITY:
      return {
        ...state,
        add: {
          ...state.add,
          loading: true
        }
      }

    case CREATE_ACTIVITY_SUCCESS:
      return {
        ...state,
        add: {
          loading: false,
          activityId: action.result.id
        }
      }

    case CREATE_ACTIVITY_FAIL:
      return {
        ...state,
        add: {
          loading: false,
          activityId: null
        }
      }

    case EDIT:
      return {
        ...state,
        edit: {
          ...state.edit,
          loading: true
        }
      }

    case EDIT_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case EDIT_FAIL:
      return {
        ...state,
        edit: {
          ...state.edit,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case APPROVAL:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: true
        }
      }

    case APPROVAL_SUCCESS:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case APPROVAL_FAIL:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        error: null,
        categories: !isEmpty(action.result)
          ? mapAwardCategories(action.result)
          : []
      }

    case GET_CATEGORIES_FAIL:
      return {
        ...state,
        error: action.error
      }

    case GET_LOGS:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: true
        }
      }

    case GET_LOGS_SUCCESS:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          loaded: true,
          error: null,
          data: action.result
        }
      }

    case GET_LOGS_FAIL:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case GET_OVERVIEW:
      return {
        ...state,
        overview: {
          ...state.overview,
          loading: true
        }
      }

    case GET_OVERVIEW_SUCCESS:
      // Remove deleted activities from response
      const data = set(
        action.result,
        'award.activities',
        get(action.result, 'award.activities', []).filter(
          activity =>
            activity.activityState.value !== ACTIVITY_STATES.deleted.id
        )
      )

      return {
        ...state,
        overview: {
          ...state.overview,
          loading: false,
          loaded: true,
          error: null,
          data
        }
      }

    case GET_OVERVIEW_FAIL:
      return {
        ...state,
        overview: {
          ...state.overview,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    default:
      return state
  }
}

/* eslint-enable */

export const createActivity = (id, data) => {
  return {
    types: [CREATE_ACTIVITY, CREATE_ACTIVITY_SUCCESS, CREATE_ACTIVITY_FAIL],
      promise: client => client.post(`api/awards/${id}/activities`, { data })
  }
}

export function setupActivity(id, data) {
  return {
    types: [SETUP, SETUP_SUCCESS, SETUP_FAIL],
    promise: client => client.post(`api/activities/${id}/setup`, { data })
  }
}

export function editActivity(id, data) {
  return {
    types: [EDIT, EDIT_SUCCESS, EDIT_FAIL],
    promise: client => client.post(`api/activities/${id}/edit`, { data })
  }
}

export function getActivityCategories() {
  return {
    types: [GET_CATEGORIES, GET_CATEGORIES_SUCCESS, GET_CATEGORIES_FAIL],
    promise: client => client.get('api/activity-categories')
  }
}

export function getLogs(id) {
  return {
    types: [GET_LOGS, GET_LOGS_SUCCESS, GET_LOGS_FAIL],
    promise: client =>
      client.get(`api/activity-logs?filter=activity.id=${id}&with=PRAISES,FILE_URLS`)
  }
}

export function getOverview(id) {
  return {
    types: [GET_OVERVIEW, GET_OVERVIEW_SUCCESS, GET_OVERVIEW_FAIL],
    promise: client =>
      client.get(
        `api/activities/${id}?with=APPEND_CUSTOMIZATIONS,ACTIVITY_CATEGORY,COMPLETED_PERCENTAGE,AWARD,ASSESSOR_ACTIVITY_CATEGORIES,ASSESSOR_REGISTRATION,ASSESSOR`
      )
  }
}

export function sendAssessmentRequest(id, data) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(`api/activities/${id}/assessment-requests`, { data })
  }
}

export function uploadPaperAssessorReport(id, data) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(`api/activities/${id}/paper-assessor-reports`, {
        data
      })
  }
}

export function sendLeaderRequest(id, data) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(`api/activities/${id}/award-leader-signoff-requests`, {
        data
      })
  }
}

export function resendAssessmentRequest(activityId) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(`api/activities/${activityId}/resend-assessment-requests`)
  }
}

export function activityAssessorRejection(activityId, data) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(`api/activities/${activityId}/assessor-rejections`, { data })
  }
}

export function uploadActivityReport(activityId, data) {
  return {
    types: [
      UPLOAD_ACTIVIT_REPORT,
      UPLOAD_ACTIVIT_REPORT_SUCCESS,
      UPLOAD_ACTIVIT_REPORT_FAIL
    ],
    promise: client =>
      client.post(`api/activities/${activityId}/paper-assessor-reports`, {
        data
      })
  }
}
